export { default as Content } from './Content';
export { default as EmptyLayout } from './EmptyLayout';
export { default as Footer } from './Footer';
export { default as Header } from './Header';
export { default as LayoutRoute } from './LayoutRoute';
export { default as MainLayout } from './MainLayout';
export { default as Sidebar } from './Sidebar';



// WEBPACK FOOTER //
// ./src/components/Layout/index.js